import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "./header.css";

export const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="navbar">
      <Link to="/" className="logo">
        Keramiek Met Een Knipoog
      
      </Link>
      <div className="menu" onClick={() => setMenuOpen(!menuOpen)}>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <ul className={menuOpen ? "nav-links open" : "nav-links"}>
        <li>
          <NavLink to="/">Home</NavLink>
        </li>
        <li>
          <NavLink to="/over">Over</NavLink>
        </li>
        <li>
          <NavLink to="/kunstgalerie">Kunstgalerie</NavLink>
        </li>
        <li>
          <NavLink to="/workshops">Workshops</NavLink>
        </li>
        <li>
          <NavLink to="/contact">Contact</NavLink>
        </li>
        <li>
          <NavLink to="/faq">FAQ</NavLink>
        </li>
      </ul>
    </nav>
  );
};